const PageContentWrapper = ({children, mb, px, className, boxShadow}) => {
    return (
        <div className="grid px-0 ">
            <div className="col-12 no-focus">
                <div
                    className={`card ${className} ${px ? px : ''} h-[100vh]`}
                    style={{
                        marginBottom: mb ? mb : 'inherit',
                        padding: 6,
                        borderRadius: '12px',
                    }}>
                    {children}
                </div>
            </div>
        </div>
    )
}

export default PageContentWrapper
